import {ReactNode} from "react";
import {Layout, Menu, MenuProps, theme} from "antd";
import {Link, useLocation} from "react-router";
import {linkMyRecipes} from "app/nav/links";
import {CurrentUserMenu} from "app/nav/CurrentUserMenu";
import {isNil} from "app/util/stdlib";

const {Header, Content, Footer} = Layout;

type MenuItem = Required<MenuProps>["items"][number];

interface IProps {
  children: ReactNode;
}

export const Shell = ({children}: IProps) => {
  const location = useLocation();
  const {
    token: {colorBgContainer, borderRadiusLG}
  } = theme.useToken();

  const items: MenuItem[] = [
    {
      key: linkMyRecipes(),
      label: <Link to={linkMyRecipes()}>My Recipes</Link>
    }
  ];

  const selectedKeys = items
    .map((item) =>
      !isNil(item?.key) && location.pathname.startsWith(item.key.toString()) ? item.key.toString() : undefined
    )
    .filter(Boolean);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Layout>
        <Header className="flex rounded-lg gap-2 items-center  shadow-lg p-4 pl-8 bg-white border-gray-700">
          <h1>CALC</h1>
          <Menu
            className="flex-1 min-w-0 bg-inherit"
            items={items}
            mode="horizontal"
            onSelect={(selectInfo) => {
              console.log({selectInfo});
            }}
            selectedKeys={selectedKeys}
          />
          <div>
            <CurrentUserMenu />
          </div>
        </Header>
        <Content className="mt-4">
          <div
            className="p-4 min-h-96"
            style={{
              background: colorBgContainer,
              borderRadius: borderRadiusLG
            }}
          >
            {children}
          </div>
        </Content>
        <Footer className="text-center">Calc ©{new Date().getFullYear()}</Footer>
      </Layout>
    </div>
  );
};
